import { useCallback, useState } from 'react';
import { CurrencyIcon } from '~/components/collections';
import { TextInput } from '~/components/ui/TextInput';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import { StyledContainer } from './MoneyInput.styled';

interface IMoneyInput {
	value: number;
	onChange: (newValue: number) => void;
	placeholder?: string;
}

const MoneyInput: React.FC<IMoneyInput> = ({
	value,
	onChange,
	placeholder,
}) => {
	const [inputValue, setInputValue] = useState<number>(value || 0);
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	const handleChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const inputValue = event.target.value.replace(/\D/g, '');

			if (inputValue.length === 0) {
				setInputValue(0);
				onChange(0);
				return;
			}

			setInputValue(parseInt(inputValue));
			onChange(parseInt(inputValue));
		},
		[],
	);

	return (
		<StyledContainer>
			<TextInput
				height={40}
				fontSize={14}
				value={inputValue ? inputValue.toLocaleString('ru-RU') : ''}
				onChange={handleChange}
				placeholder={placeholder}
				tabIndex={-1}
				style={{ paddingRight: 34 }}
			/>
			<CurrencyIcon icon={rubleIcon} size="md" />
		</StyledContainer>
	);
};

export { MoneyInput };
